import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TrafficIcon(props: IconProps) {
    return <Icon {...props} iconKey={"traffic"}/>
}
